import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import { useLocale } from '@/shared/composables/useLocale'
import { i18n } from '@/app/plugins/i18n'
import { SentryLib } from '@/app/plugins/sentry/sentry'
import packageJson from '../../package.json'
import router from '@/app/router/router'
import QicConnectPlugin from '@qicgroupdoha/qic-connect-ds/plugin'

import { clarityService } from '@qicgroupdoha/qic-use/clarity'

import '@qicgroupdoha/qic-connect-ds/style.css'
import '@/shared/assets/scss/styleRebranding.scss'

const logVersion = () => {
  console.log(`version: ${packageJson.version}.${__COMMIT_HASH__}`)
}

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)

const { locale } = useLocale()

logVersion()
app.provide('localeRTL', locale === 'ar')

SentryLib.init(app, router)

pinia.use(({ store }) => {
  store.$router = router
})

app.use(router)
app.use(i18n)
app.use(QicConnectPlugin, {})

clarityService.init({
  projectId: import.meta.env.VUE_APP_CLARITY_PROJECT_ID,
  router,
  trackedQueryKeys: ['platform', 'version'],
})

app.mount('#app')
